{
  "version": 1,
  "asset_id": "c630c9e9-215c-45ed-85b3-e9b72da0059e",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/c630c9e9-215c-45ed-85b3-e9b72da0059e/og-irs-collections-defense.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/c630c9e9-215c-45ed-85b3-e9b72da0059e/og-irs-collections-defense.jpg",
  "original_filename": "og-irs-collections-defense.jpg",
  "size": 182043,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T16:20:21Z"
}
